import { PortalArea } from "../types/shared/routes/routeHelperClasses";
import ConradDispatchLogo from '../../images/Conrad_Dispatch_Icon.png';
import { IPortalAreaOptions } from "../types/shared/routes/routeTypes";
import { DispatchPermissions } from "../types/shared/auth/permissionsTypes";
import DispatchHomePageConfig from "../../pages/dispatch/DispatchHomePage";
import FailedPNPageConfig from "../../pages/dispatch/FailedPnPage";
import FailedPerformanceFilePagePageConfig from "../../pages/dispatch/FailedPerformanceFilePage";
import DispatchAlertPageConfig from "../../pages/dispatch/DispatchAlertManagementPage";

const areaOptions: IPortalAreaOptions = {
    title: "Dispatch",
    description: "Dispatch, Generation, Monitoring",
    iconImage: ConradDispatchLogo,
    allValidPermissions: { Dispatch: DispatchPermissions.AllPermissions }
}

const DispatchPortalArea = new PortalArea(areaOptions, DispatchHomePageConfig);
DispatchPortalArea.addChildRoute(FailedPNPageConfig);
DispatchPortalArea.addChildRoute(FailedPerformanceFilePagePageConfig);
DispatchPortalArea.addChildRoute(DispatchAlertPageConfig);

export default DispatchPortalArea;
